import { render, useState, useEffect } from '@wordpress/element';
import Dashboard from './Dashboard';
import Blocks from './Blocks';
import Patterns from './Patterns';
import Settings from './Settings';
import Icon from './Icon';

const App = () => {
    // Retrieve the last active tab from localStorage or default to 'dashboard'
    const getInitialTab = () => {
        const savedTab = localStorage.getItem('activeTab');
        return savedTab ? savedTab : 'dashboard';
    };

    const [activeTab, setActiveTab] = useState(getInitialTab);

    useEffect(() => {
        // Save the active tab to localStorage whenever it changes
        localStorage.setItem('activeTab', activeTab);
    }, [activeTab]);

    const renderContent = () => {
        switch (activeTab) {
            case 'dashboard':
                return <Dashboard />;
            case 'blocks':
                return <Blocks />;
            case 'patterns':
                return <Patterns />;
            case 'settings':
                return <Settings />;
            default:
                return <Dashboard />;
        }
    };

    return (
        <div className="p-4">
            <div className="flex mb-6 bg-white px-6 py-4 rounded gap-3">
                <button
                    className={`flex items-center px-6 py-3 rounded ${activeTab === 'dashboard' ? 'bg-blue-50 text-blue-500' : 'bg-white hover:bg-blue-50'}`}
                    onClick={() => setActiveTab('dashboard')}
                >
                    <Icon iconType="dashboard" />
                    Dashboard
                </button>
                <button
                    className={`flex items-center px-6 py-3 rounded ${activeTab === 'blocks' ? 'bg-blue-50 text-blue-500' : 'bg-white hover:bg-blue-50'}`}
                    onClick={() => setActiveTab('blocks')}
                >
                    <Icon iconType="blocks" />
                    Blocks
                </button>
                <button
                    className={`flex items-center px-6 py-3 rounded ${activeTab === 'patterns' ? 'bg-blue-50 text-blue-500' : 'bg-white hover:bg-blue-50'}`}
                    onClick={() => setActiveTab('patterns')}
                >
                    <Icon iconType="patterns" />
                    Patterns
                </button>
                <button
                    className={`flex items-center px-6 py-3 rounded ${activeTab === 'settings' ? 'bg-blue-50 text-blue-500' : 'bg-white hover:bg-blue-50'}`}
                    onClick={() => setActiveTab('settings')}
                >
                    <Icon iconType="settings" />
                    Settings
                </button>
            </div>
            <div>
                {renderContent()}
            </div>
        </div>
    );
};

export default App;
